import type {
  SendSetPasswordEmailMutation,
  SendSetPasswordEmailMutationVariables,
} from "@generated/graphql";
import { SEND_SET_PASSWORD_EMAIL_MUTATION } from "clientState/operations/mutations";
import {
  useMutation,
  type UseMutationResult,
} from "@edreamsodigeo/frontend-api-client";

export const useSendSetPasswordEmail = (): UseMutationResult<
  SendSetPasswordEmailMutation,
  SendSetPasswordEmailMutationVariables
> => {
  return useMutation(SEND_SET_PASSWORD_EMAIL_MUTATION);
};

export default useSendSetPasswordEmail;
